"use client";

import React, { useEffect, useState } from "react";

import { Product } from "../../../payload/payload-types";
import { AddToCartButton } from "../AddToCartButton";
import { RemoveFromCartButton } from "../RemoveFromCartButton";

import classes from "./index.module.scss";

export const priceFromJSON = (priceJSON: string, quantity: number = 1, raw?: boolean): string => {
  let price = "";

  if (priceJSON) {
    try {
      const parsed = JSON.parse(priceJSON)?.data[0];
      const priceValue = parsed.unit_amount * quantity;
      const priceType = parsed.type;

      if (raw) return priceValue.toString();

      price = (priceValue / 100).toLocaleString("en-NG", {
        style: "currency",
        currency: "NGN",
      });

      if (priceType === "recurring") {
        price += `/${parsed.recurring.interval_count > 1 ? `${parsed.recurring.interval_count} ${parsed.recurring.interval}` : parsed.recurring.interval}`;
      }
    } catch (e) {
      console.error(`Cannot parse priceJSON`); // eslint-disable-line no-console
    }
  }

  return price;
};

export const priceFromProduct = (priceProduct, quantity): string => {
  let price = "";
  if (priceProduct) {
    try {
      // const parsed = JSON.parse(priceJSON)?.data[0]
      // const priceValue = parsed.unit_amount * quantity
      // const priceType = parsed.type

      //if (raw) return priceValue.toString()
      quantity = quantity === undefined ? 1 : quantity;

      let finalPrice = parseInt(priceProduct) * parseInt(quantity);
      price = finalPrice.toLocaleString("en-NG", {
        style: "currency",
        currency: "NGN",
      });

      return price;

      // if (priceType === 'recurring') {
      //   price += `/${
      //     parsed.recurring.interval_count > 1
      //       ? `${parsed.recurring.interval_count} ${parsed.recurring.interval}`
      //       : parsed.recurring.interval
      //   }`
      // }
    } catch (e) {
      console.error(`Cannot parse priceJSON`); // eslint-disable-line no-console
    }
  }

  return price;
};

export const Price: React.FC<{
  product: Product;
  quantity?: number;
  button?: "addToCart" | "removeFromCart" | false;
}> = (props) => {
  const { product, product: { priceJSON } = {}, button = "addToCart", quantity } = props;

  //console.log('Props priceJSON is', priceJSON)

  const [price, setPrice] = useState<{
    actualPrice: string;
    withQuantity: string;
  }>(() => ({
    actualPrice: priceFromJSON(priceJSON),
    withQuantity: priceFromJSON(priceJSON, quantity),
  }));

  useEffect(() => {
    setPrice({
      actualPrice: priceFromJSON(priceJSON),
      withQuantity: priceFromJSON(priceJSON, quantity),
    });
  }, [priceJSON, quantity]);

  return (
    <div className={classes.actions}>
      {product.salesPrice ? (
        <div>
          <s>{priceFromProduct(product.price, quantity)}</s> <span className={classes.salesPrice}>{priceFromProduct(product.salesPrice, quantity)}</span>
        </div>
      ) : (
        <span>{priceFromProduct(product.price, quantity)}</span>
      )}

      {typeof price?.actualPrice !== "undefined" && price?.withQuantity !== "" && (
        <div className={classes.price}>
          <p>{price?.withQuantity}</p>
          {quantity > 1 && <small className={classes.priceBreakdown}>{`${price.actualPrice} x ${quantity}`}</small>}
        </div>
      )}
      {/* {button && button === "addToCart" && (
        <AddToCartButton
          product={product}
          appearance="default"
        />
      )}
      {button && button === "removeFromCart" && <RemoveFromCartButton product={product} />} */}
    </div>
  );
};
